import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import VideoAutoplayInView from './VideoAutoplayInView'

import { IS_WEB } from '../../config/'

function HomePageSubSectionMediaContent ({
  mediaType,
  video,
  image,
  mobileImage,
  greaterThanMd
}) {
  const isVideo = mediaType === 'video' && video && video.length > 0
  if (!isVideo) {
    // image mode.
    // if we have a separate mobile image,
    // use picture element so we can load and show different images to different device sizes.
    if (mobileImage) {
      return (
        <picture className='block'>
          <source srcSet={image} media='(min-width: 800px)' />
          <source srcSet={mobileImage} />
          <img className='block' src={mobileImage} />
        </picture>
      )
    }
    // else, just output the image
    return <img className='block' src={image} />
  }

  // video mode.
  // if a mobileImage is provided, then we conditionally only show the video
  // for large screens, and a image otherwise. To avoid downloading too much,
  // since we don't know the screen size on the server, we return null on the server in that case
  // If this component should be fully re-usable we would need to make this optional.
  if (mobileImage && !IS_WEB) {
    return null
  }
  // we have a mobileImage and small screen - use the image
  if (!greaterThanMd && mobileImage) {
    return <img className='block' src={mobileImage} />
  }
  // otherwise use the video!
  return <VideoAutoplayInView src={`/static/videos/screencasts/${video}`} />
}
const HOCHomePageSubSectionMediaContent = connect(({ browser }) => ({
  greaterThanMd: browser.greaterThan.md
}))(HomePageSubSectionMediaContent)

// NOTE: this Component is currently only used for the Build assistant section
// on the HomePage.
function HomePageSubSection ({ title, text, mediaPosition, ...mediaProps }) {
  return (
    <section className='homepage__subsection'>
      <div
        className={classnames(
          {
            'homepage__subsection__flex-wrapper--reversed':
              mediaPosition === 'start'
          },
          'homepage__subsection__flex-wrapper flex flex-wrap'
        )}
      >
        <div className='homepage__subsection-text bg-light-grey'>
          <h3 className='homepage__subsection-title h3 blue mb2'>{title}</h3>
          <p className='text-para'>{text}</p>
        </div>
        <div className='homepage__subsection-media relative'>
          <HOCHomePageSubSectionMediaContent {...mediaProps} />
        </div>
      </div>
    </section>
  )
}

export default HomePageSubSection



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/HomePageSubSection.js